
import CollapsibleNav from '@/components/nav/common/CollapsibleNav.vue';
import { StorageEnum } from '@/lib/enum/StorageEnum';
import { NavSectionInterface } from '@/lib/navigation/helpers';
import { reportsNav } from '@/lib/navigation/reportsNav';
import { setLocalStorageItem } from '@/util/storageFunctions';

export default {
  name: 'ReportsNav',
  components: { CollapsibleNav },
  beforeRouteEnter(to, from, next) {
    setLocalStorageItem(StorageEnum.FromRoute, from.name);
    next();
  },
  data() {
    return {
      nav: [] as NavSectionInterface[],
    };
  },
  async mounted() {
    const sections = [
      reportsNav.timeOff(),
      reportsNav.timeAttendance(),
      reportsNav.logs(),
    ];
    try {
      const resolvedShiftCostSection = await reportsNav.shiftCost();
      if (!resolvedShiftCostSection.hide) {
        sections.unshift(resolvedShiftCostSection);
      }
    } finally {
      this.nav = sections;
    }
  },
};
